import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { useProjectState } from "../../../context/stateContext";
import appActions from "../../../redux/getOrganizationAndRestaurant/actions";
import AreasInfoActions from "../../../components/User/AreasComponents/AreasInfoActions";
import AreasInfoTable from "../../../components/User/AreasComponents/AreasInfoTable";
import PageHeader from "../../../components/Common/PageHeader/PageHeader";

const { getRestaurants } = appActions;

const AreasInfo = () => {
  const { selectedOrganization } = useProjectState();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getRestaurants());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization]);

  return (
    <>
      <PageHeader text="Справка по обекти" date={true} />
      <AreasInfoActions />
      <AreasInfoTable />
    </>
  );
};

export default AreasInfo;
